import { create } from 'zustand';

/**
 * Animator Control (Phase 2B) — pont interne entre ScreenApp (qui lit les params du
 * jeu dans Firestore : screenInfos.anim.gameParams) et le bridge de l'iframe
 * (useWebViewPlugin, qui les relaie au jeu via le message 'set-game-params').
 *
 * `params` = derniers paramètres réglés par l'animateur (blob opaque), null tant
 * qu'aucun réglage. État idempotent (≠ le nonce one-shot du lancement) : re-pousser
 * les mêmes params est sans effet, donc pas de garde « valeur au montage » nécessaire.
 */
type RemoteGameParamsStore = {
    params: Record<string, unknown> | null;
    set: (params: Record<string, unknown> | null) => void;
};

export const useRemoteGameParams = create<RemoteGameParamsStore>((setState) => ({
    params: null,
    set: (params) => setState({ params }),
}));
